module.exports = {
    'coupons.show': 'coupons/$1',
    'lapsed.coupons.show': 'lapsed/coupons/$1',
    'pause-coupon': 'get-pause-coupon',
    'redeem-pause-coupon': 'redeem-pause-coupon',
};
